import { render, staticRenderFns } from "./module.vue?vue&type=template&id=2bbf7ae5&"
import script from "./module.vue?vue&type=script&lang=js&"
export * from "./module.vue?vue&type=script&lang=js&"
import style0 from "./module.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "module.vue"
export default component.exports